import { render, staticRenderFns } from "./ColorPickerApp.vue?vue&type=template&id=5ac4797d&"
import script from "./ColorPickerApp.vue?vue&type=script&lang=js&"
export * from "./ColorPickerApp.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/tine20/Tinebase/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac4797d')) {
      api.createRecord('5ac4797d', component.options)
    } else {
      api.reload('5ac4797d', component.options)
    }
    module.hot.accept("./ColorPickerApp.vue?vue&type=template&id=5ac4797d&", function () {
      api.rerender('5ac4797d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ux/form/ColorPickerApp.vue"
export default component.exports